import i18n from "@/i18n";
const isEn = i18n.locale === "en";
const {
  topList: topListLang,
  navigationList: navigationListLang,
  navigationList2: navigationListLang2,
  navigationList3: navigationListLang3,
  progressData: progressDataLang,
  brandList: brandListLang,
  footerData: footerDataLang,
  developList: developListLang,
  dASData: dASDataLang,
  bannerList: bannerListLang
} = i18n.t("dictionary");
// 最顶部
const topList = [
  {
    id: "topList-1",
    text: topListLang[0],
    src: "https://img.topsfilm.com/newportal/img/top/top-1.png",
    href: "/Query/Warranty"
  },
  {
    id: "topList-2",
    text: topListLang[1],
    src: "https://img.topsfilm.com/newportal/img/top/top-2.png",
    href: "/Query/Distributor"
  },
  {
    id: "topList-3",
    text: topListLang[2],
    src: "https://img.topsfilm.com/newportal/img/top/top-3.png",
    href: "/Query/Offer"
  }
];
// 导航区域字段
const navigationList = [
  {
    id: "Adout",
    text: "关于拓弗勒",
    href: "/"
  },
  {
    id: "Product",
    text: "产品中心",
    href: "",
    children: [
      {
        id: "Paint",
        value: 26,
        text: "漆面保护膜",
        href: "/Product/Paint"
      },
      {
        id: "G",
        value: 28,
        text: "G速膜(汽车窗膜)",
        href: "/Product/G"
      },
      {
        id: "ColorChange",
        value: 62,
        text: "改色膜",
        href: "/Product/ColorChange"
      },
      // {
      //   id: 'Colorful',
      //   text: '炫彩膜',
      //   href: '/Product/Colorful'
      // },
      {
        id: "SkyLight",
        value: 41,
        text: "天窗铠甲",
        href: "/Product/Skylight"
      },
      {
        id: "HeadlightFilm",
        value: 42,
        text: "大灯膜",
        href: "/Product/HeadlightFilm"
      }
    ]
  },
  {
    id: "Solution",
    text: "解决方案",
    href: "",
    children: [
      {
        id: "Solution-train",
        text: "培训",
        children: [
          {
            id: "train-1",
            text: "安装培训",
            href: "/Solution/Train"
          }
          // ,
          // {
          //   id: 'train-2',
          //   text: '窗膜安装培训',
          //   href: '/Solution/Train2'
          // }
        ]
      },
      {
        id: "Solution-become",
        text: "成为经销商",
        children: [
          {
            id: "become-1",
            text: "加入经销商",
            href: "/Solution/Installer"
          }
        ]
      },
      {
        id: "Solution-software",
        text: "软件",
        children: [
          {
            id: "software-1",
            text: "DAS 3D裁膜数据辅助系统",
            href: "/Solution/DAS"
          }
        ]
      }
    ]
  },
  {
    id: "Case",
    text: "精彩案例",
    href: "",
    children: [
      {
        id: "Paint",
        text: "漆面保护膜",
        href: "/Case"
      },
      {
        id: "G",
        text: "G速膜(汽车窗膜)",
        href: "/Case"
      },
      {
        id: "ColorChange",
        text: "改色膜",
        href: "/Case"
      },
      // {
      //   id: 'Colorful',
      //   text: '炫彩膜',
      //   href: '/Case'
      // },
      {
        id: "SkyLight",
        text: "天窗铠甲",
        href: "/Case"
      }
    ]
  },
  {
    id: "Dynamic",
    text: "品牌动态",
    href: "/Dynamic"
  },
  // {
  // id: 'Help',
  // text: '帮助',
  // href: '/Help',
  // children: [{
  //     id: 'Support',
  //     text: '技术支持',
  //     href: '/Help/Support'
  //   },
  //   {
  //     id: 'Problem',
  //     text: '常见问题',
  //     href: '/Help/Problem'
  //   },
  //   {
  //     id: 'Authentication',
  //     text: '认证',
  //     href: '/Help/Authentication'
  //   }, {
  //     id: 'Maintain',
  //     text: '保养',
  //     href: '/Help/Maintain'
  //   }, {
  //     id: 'SafelyFactor',
  //     text: '产品安全参数',
  //     href: '/Help/SafelyFactor'
  //   },
  //   {
  //     id: 'Warranty',
  //     text: '质保信息',
  //     href: '/Help/Warranty'
  //   }, {
  //     id: 'Guidance',
  //     text: '安装指导',
  //     href: '/Help/Guidance'
  //   }
  // ]
  // },
  {
    id: "Address",
    text: "所在地",
    href: "",
    children: [
      {
        id: "Address-Germany",
        text: "德国",
        href: "https://topsfilm.com/"
      },
      {
        id: "Address-England",
        text: "英国",
        href: "https://topsfilm.com/"
      },
      {
        id: "Address-USA",
        text: "美国",
        href: "https://topsfilm.com/"
      },
      {
        id: "Address-China",
        text: "中国",
        href: ""
      },
      {
        id: "Address-HK",
        text: "香港(中国)",
        href: ""
      },
      {
        id: "Address-Japan",
        text: "日本",
        href: "https://topsfilm.com/"
      },
      {
        id: "Address-Australia",
        text: "澳大利亚",
        href: "https://topsfilm.com/"
      },
      {
        id: "Address-Othercountry",
        text: "其他国家",
        href: "https://topsfilm.com/"
      }
    ]
  }
];

if (isEn) {
  navigationList.forEach((item, index) => {
    item.text = navigationListLang[index];
    if (item.children) {
      item.children.forEach((ele, idx) => {
        ele.text = navigationListLang2[item.id][idx];
        if (ele.children) {
          ele.children.forEach((x, i) => {
            x.text = navigationListLang3[ele.id][i];
          });
        }
      });
    }
  });
}

// 轮播图
// const bannerList = [
//   {
//     id: "banner-5",
//     src: "https://img.topsfilm.com/newportal/img/banner/banner5.png"
//   },
//   {
//     id: "banner-1",
//     src: "https://img.topsfilm.com/newportal/img/banner/banner1.png"
//   },
//   {
//     id: "banner-2",
//     src: "https://img.topsfilm.com/newportal/img/banner/banner2.png"
//   },
//   {
//     id: "banner-3",
//     src: "https://img.topsfilm.com/newportal/img/banner/banner3.png"
//   },
//   {
//     id: "banner-4",
//     src: "https://img.topsfilm.com/newportal/img/banner/banner4.png"
//   },
//   {
//     id: "banner-6",
//     src: "https://img.topsfilm.com/newportal/img/banner/banner6.png"
//   },
//   {
//     id: "banner-7",
//     src: "https://img.topsfilm.com/newportal/img/banner/banner7.png"
//   },
//   {
//     id: "banner-8",
//     src: "https://img.topsfilm.com/newportal/img/banner/banner1.png"
//   }
// ];
const bannerList = [
  {
    id: "banner-5",
    src: "https://img.topsfilm.com/newportal/img/banner/0616/zh/1.png"
  },
  {
    id: "banner-1",
    src: "https://img.topsfilm.com/newportal/img/banner/0616/zh/2.png"
  },
  {
    id: "banner-2",
    src: "https://img.topsfilm.com/newportal/img/banner/0616/zh/3.png"
  },
  {
    id: "banner-3",
    src: "https://img.topsfilm.com/newportal/img/banner/0616/zh/4.png"
  },
  {
    id: "banner-4",
    src: "https://img.topsfilm.com/newportal/img/banner/0616/zh/5.png"
  },
  {
    id: "banner-6",
    src: "https://img.topsfilm.com/newportal/img/banner/0616/zh/6.png"
  },
  {
    id: "banner-7",
    src: "https://img.topsfilm.com/newportal/img/banner/0616/zh/1.png"
  }
];
if (isEn) {
  bannerList.forEach((item, index) => {
    //item.unit = developListLang[index].id;
    item.src = bannerListLang[index].src;
  });
}
// 发展现状及历程
const developList = [
  {
    id: "develop-1",
    num: "6",
    unit: "年",
    text: "质量0投诉"
  },
  {
    id: "develop-2",
    num: "46",
    unit: "年",
    text: "膜品生产历史"
  },
  {
    id: "develop-3",
    num: "200000",
    unit: "",
    text: "豪车施工"
  },
  {
    id: "develop-4",
    num: "500",
    unit: "",
    text: "合作门店"
  }
];
if (isEn) {
  developList.forEach((item, index) => {
    item.unit = developListLang[index].unit;
    item.text = developListLang[index].text;
  });
}

const progressData = {
  first: {
    id: "progress-1",
    title: "启程",

    content: [
      {
        id: "progress-1-1",
        code: 1,
        text: "1978年，TOPS拓弗勒于德国慕尼黑建立工厂。"
      }
    ]
  },
  second: {
    id: "progress-2",
    title: "初程",
    content: [
      {
        id: "progress-2-1",
        code: 2,
        top: "58px",
        text: "2016年，TOPS拓弗勒研发中心于德国慕尼黑成立。"
      },
      {
        id: "progress-2-2",
        code: 3,
        text:
          '2018年，TOPS拓弗勒旗下汽车漆面保护膜品牌<br/><span class="text-white">TOPPF拓弗®</span>推向全球市场。'
      },
      {
        id: "progress-2-3",
        code: 4,
        text: "2019年01月，中国上海TOPS拓弗勒亚太营销中心成立。"
      },
      {
        id: "progress-2-4",
        code: 5,
        text: "2019年03月，中国上海TOPS拓弗勒亚太区培训中心成立。"
      },
      {
        id: "progress-2-5",
        code: 6,
        text: "2019年03月，中国上海TOPPF拓弗品牌旗舰店建立。"
      },
      {
        id: "progress-2-6",
        code: 7,
        text:
          '2019年06月，<span class="text-white">TOPPF拓弗®漆面保护膜</span>TPU四大<br/>系列新品全球首发。'
      },
      {
        id: "progress-2-7",
        code: 8,
        text:
          "2019年08月，品牌TOPPF拓弗®首次参展CIAIE2019<br/>中国上海国际汽车内饰与外饰展览会 。"
      }
    ]
  },
  third: {
    id: "progress-3",
    title: "征程",
    content: [
      {
        id: "progress-3-1",
        code: 9,
        text:
          "2020年，TOPS拓弗勒与蔚来汽车以及豪车集团<br/>达成合作，成为内外饰膜及窗膜指定供应商。"
      },
      {
        id: "progress-3-2",
        code: 10,
        text:
          '2020年01月，<span class="text-white">TOPPF拓弗®漆面保护膜炫彩系列、<br/>TOPS Film™ </span>G速膜新品全球首发。'
      },
      {
        id: "progress-3-3",
        code: 11,
        text:
          "2020年07月，TOPPF拓弗®在第16届格兰彼治中国汽车<br/>后市场年度总榜中被评为“汽车漆面保护膜十强品牌”。"
      },
      {
        id: "progress-3-4",
        code: 12,
        text:
          '2020年09月，<span class="text-white">TOPPF拓弗®天窗铠甲战神Týr帝尔<br/>系列、TOPS Film™ </span>G速膜色界系列新品全球首发。'
      },
      {
        id: "progress-3-5",
        code: 13,
        text: "2021年01月，TOPS拓弗勒中国赞助同济DIAN Racing<br/>电车队。"
      },
      {
        id: "progress-3-6",
        code: 14,
        text:
          '2021年05月，TOPS拓弗勒旗下车身改色膜及高端<br/>定制彩绘品牌<span class="text-white">TOPS Color Your Infinity™</span>正式创立。'
      },
      {
        id: "progress-3-7",
        code: 15,
        text: "2021年08月，TOPS拓弗改色膜新品新品全球首发。"
      },
      {
        id: "progress-3-8",
        code: 16,
        text:
          "2021年11月，TOPS拓弗勒与德国RALColours劳尔</br>色彩达成战略合作。"
      }
    ]
  },
  fourth: {
    id: "progress-4",
    title: "鸿程·拓无止境"
  }
};
if (isEn) {
  for (const k in progressData) {
    const curD = progressData[k];
    curD.title = progressDataLang[k].title;
    if (curD.content) {
      curD.content.forEach((item, index) => {
        if (progressDataLang[k].content[index]) {
          item.text = progressDataLang[k].content[index];
        } else {
          item.text = '';
        }

      });
    }
  }
}

// 品牌介绍
const brandList = [
  {
    id: "brandList-1",
    title: "漆面保护膜",
    style: {
      padding: "205px 36px 0 60px"
    },
    logo: "https://img.topsfilm.com/newportal/img/brand/logo.png",
    src: "https://img.topsfilm.com/newportal/img/brand/brand-1.png",
    bgcImg: "https://img.topsfilm.com/newportal/img/brand/brand-bgc-1.png",
    content:
      "漆面保护膜包括TOUR拓系列、TOUR PLUS拓+系列、PHANTOM幻影系列、PHANTOM MATTE幻影哑光系列、FEDER羽裳系列、F1系列，采用8mil-10mil 光学级TPU+基材，第四代V+涂层纳米胶囊技术，提供强抗污、高炫亮、耐黄变功能，防止鸟粪和大气中粉尘侵蚀，阻隔紫外线穿透，防御刮擦和石子弹射，具有疏水自洁功能，防止水垢的污染，小刮小擦自动修复，保护汽车车身原厂漆状态，保持油漆表面光泽度。拓弗漆面膜具有专有涂敷工艺，平整光亮，零胶痕，易施工。"
  },
  {
    id: "brandList-4",
    title: "(汽车窗膜)",
    style: {
      padding: "148px 76px 0 88px"
    },
    logo: "https://img.topsfilm.com/newportal/img/brand/logo3.png",
    src: "https://img.topsfilm.com/newportal/img/brand/brand-4.png",
    bgcImg: "https://img.topsfilm.com/newportal/img/brand/brand-bgc-4.png",
    content:
      "汽车隔热窗膜，即G速膜，包括Diamond晶曜®系列、Super<br/>Diamond晶曜®尊享系列、Dynamic色界™ 系列、Crystal晶<br/>悦系列，创新变色涂层专有技术，独有纳米石墨烯隔热涂层<br/>技术，可阻隔太阳光中的热辐射，营造凉爽舒适的驾乘环境，<br/>有效防止99%紫外线辐射，减少紫外线对肌肤和眼睛的伤害；<br/>减少驾驶过程中眩光造成的危害，确保视野清晰，驾驶安全。<br/>科学光谱选择技术确保视野清晰，避免模糊视野对视力伤害；<br/>膜表面的防划伤涂层，避免因频繁升降玻璃和外力挤擦引，<br/>发生事故时，有助于固定破损玻璃的碎片；隔热功能有助于<br/>降低油耗，延长空调压缩机寿命，减少空调负荷，提高燃油<br/>效率。"
  },
  {
    id: "brandList-5",
    title: "改色膜",
    style: {
      padding: "204px 36px 0 80px"
    },
    logo: "https://img.topsfilm.com/newportal/img/brand/logo4.png",
    src: "https://img.topsfilm.com/newportal/img/brand/brand-5.png",
    bgcImg: "https://img.topsfilm.com/newportal/img/brand/brand-bgc-5.png",
    content:
      "TOPS拓弗改色膜采用德国铸造级颜色层，创新光学保护膜层，以及创新聚氯乙烯膜技术，多元化呈现色彩质感与饱和度；TOPS拓弗改色膜与德国百年色彩研究机构RAL劳尔色彩达成战略合作，以源自德国、高端配色作为产品定位，以Color Your Infinity色无止境作为品牌理念，为用户提供奢享版、尊享版、经典版三大版本，共12个色系，百余款高端潮流改色方案。TOPS拓弗改色膜奢享版TPU改色膜，采用TPU基材，创新色彩涂层涂敷工艺，采用第四代V+涂层纳米胶囊技术，具有高倍韧性和自修复能力，提供改色和保护双重功效。      "
  },
  {
    id: "brandList-2",
    title: "高端定制彩绘",
    style: {
      padding: "158px 63px 0 50px"
    },
    logo: "https://img.topsfilm.com/newportal/img/brand/logo4.png",
    src: "https://img.topsfilm.com/newportal/img/brand/brand-2.png",
    bgcImg: "https://img.topsfilm.com/newportal/img/brand/brand-bgc-2.png",
    content:
      "德国TOPS Color Your Infinity™拓弗®高端定制彩绘，潮流炫酷，引领时尚，个性张扬，高端定制。拓弗彩绘膜不仅仅只有潮酷的外表，拓弗独有创新高端基材，强度大、伸缩性强且亮度高。具有强大的保护漆面、防止沙石飞溅损伤车体、遮盖车身划痕、环保安全等特点。同时采用专业打印设备和颜色定制喷墨墨水，高度还原色彩、不褪色。      "
  },
  {
    id: "brandList-3",
    title: "天窗铠甲",
    style: {
      padding: "206px 36px 0 85px"
    },
    logo: "https://img.topsfilm.com/newportal/img/brand/logo.png",
    src: "https://img.topsfilm.com/newportal/img/brand/brand-3.png",
    bgcImg: "https://img.topsfilm.com/newportal/img/brand/brand-bgc-3.png",
    content:
      "天窗铠甲战神TYR帝尔系列，甄选8.5mil TPU基材，耐用可靠安全<br/>防爆，杜绝天窗意外破碎隐患，时刻守护行车安全。高科技材料自<br/>动识别光谱，阻隔95%红外线，高效隔热快速降温，守护舒适出行<br/>生活。阻隔99.99%紫外线，防晒指数等同于200层SPF50+PA+++<br/>的防晒霜，物理防晒贴心护肤，同时保护汽车内饰远离老化。采用<br/>德国专有创新V+涂层，日常刮擦迅速自我修复，不留痕迹保持视野<br/>清晰通透。颠覆传统硬质材料，软膜按照效率跨越式提升，外部装<br/>贴轻松施工，极速提车无需等候。"
  }
];

if (isEn) {
  brandList.forEach((item, index) => {
    const temItem = brandListLang[index];
    if (!temItem.title) return;
    item.title = temItem.title;
    item.content = temItem.content;
    if (temItem.logo) {
      item.logo = temItem.logo;
    }
  });
}

// footer
const footerData = {
  product: {
    id: "footer-1",
    title: "产品中心",
    content: [
      {
        id: "footer-1-2",
        text: "漆面保护膜",
        src: "/Product/Paint"
      },
      {
        id: "footer-1-1",
        text: "G速膜(汽车窗膜)",
        src: "/Product/G"
      },
      {
        id: "footer-1-3",
        text: "改色膜",
        src: "/Product/ColorChange"
      },
      {
        id: "footer-1-4",
        text: "天窗铠甲",
        src: "/Product/SkyLight"
      },
      {
        id: "footer-1-5",
        text: "大灯膜",
        src: "/Product/HeadlightFilm"
      }
    ]
  },
  Solution: {
    id: "Solution",
    title: "解决方案",
    content: [
      // {
      //   id: "footer-8-1",
      //   text: "培训"
      //   // content: [
      //   //   {
      //   //     id: "footer-8-1-1",
      //   //     text: "安装培训",
      //   //     src: "/Solution/Train"
      //   //   }
      //   //   // , {
      //   //   //   id: 'footer-8-1-2',
      //   //   //   text: '窗膜安装培训',
      //   //   //   src: '/Solution/Train2',
      //   //   // }
      //   // ]
      // },
      {
        id: "footer-8-1-1",
        text: "安装培训",
        src: "/Solution/Train"
      },
      // {
      //   id: 'footer-8-2',
      //   text: '成为经销商',
      //   content: [{
      //     id: 'footer-8-2-1',
      //     text: '专业安装人员',
      //     src: '/Solution/Installer'
      //   }]
      // },
      // {
      //   id: "footer-8-3",
      //   text: "软件",
      //   content: []
      // },
      {
        id: "footer-8-3-1",
        text: "DAS 3D裁膜数据辅助系统",
        src: "/Solution/DAS"
      }
    ]
  },
  // service: {
  //   id: 'footer-2',
  //   title: '服务中心',
  //   content: [{
  //     id: 'footer-2-1',
  //     text: '我的账户'
  //   }, {
  //     id: 'footer-2-2',
  //     text: '保养'
  //   }, {
  //     id: 'footer-2-3',

  //     text: '报价查询'
  //   }, {
  //     id: 'footer-2-4',

  //     text: '产品安全参数'
  //   }, {
  //     id: 'footer-2-5',

  //     text: '技术支持'
  //   }, {
  //     id: 'footer-2-6',
  //     text: '质保信息'

  //   }, {
  //     id: 'footer-2-7',
  //     text: '常见问题'
  //   }, {
  //     id: 'footer-2-8',
  //     text: '安装指导'
  //   }, {
  //     id: 'footer-2-9',
  //     text: '认证'
  //   }, {
  //     id: 'footer-2-10',
  //     text: '技师培训体系'
  //   }]
  // },
  case: {
    id: "footer-3",
    title: "精彩案例",
    content: [
      {
        id: "footer-3-1",
        text: "漆面保护膜",
        src: "/Case",
        code: "Paint"
      },
      {
        id: "footer-3-2",
        text: "G速膜(汽车窗膜)",
        src: "/Case",
        code: "G"
      },
      {
        id: "footer-3-3",
        text: "改色膜",
        src: "/Case",
        code: "ColorChange"
      },
      {
        id: "footer-3-4",
        text: "天窗铠甲",
        src: "/Case",
        code: "SkyLight"
      }
    ]
  },
  // help: {
  //   id: "footer-7",
  //   title: "帮助",
  //   content: [
  //     {
  //       id: "footer-7-1",
  //       text: "技术支持",
  //       src: "/Support"
  //     },
  //     {
  //       id: "footer-7-2",
  //       text: "常见问题",
  //       src: "/Problem"
  //     },
  //     {
  //       id: "footer-7-3",
  //       text: "认证",
  //       src: "/Authentication"
  //     },
  //     {
  //       id: "footer-7-4",
  //       text: "保养",
  //       src: "/Maintain"
  //     },
  //     {
  //       id: "footer-7-5",
  //       text: "产品安全参数",
  //       src: "/SafelyFactor"
  //     },
  //     {
  //       id: "footer-7-6",
  //       text: "质保信息",
  //       src: "/Warranty"
  //     },
  //     {
  //       id: "footer-7-7",
  //       text: "安装指导",
  //       src: "/Guidance"
  //     }
  //   ]
  // },
  // store: {
  //   id: 'footer-4',
  //   title: '门店/经销商查询',
  //   content: [{
  //     id: 'footer-4-1',
  //     text: '经销商'
  //   }, {
  //     id: 'footer-4-2',
  //     text: '门店形象展示'
  //   }, {
  //     id: 'footer-4-3',
  //     text: '三膜一体潮牌店'
  //   }]
  // },
  brand: {
    id: "footer-5",
    title: "品牌动态",
    content: [
      {
        id: "footer-5-1",
        text: "新闻资讯",
        src: "/Dynamic"
      }
      // , {
      // id: 'footer-5-2',
      // text: '精彩活动',
      // src: '/Dynamic'
      // }
    ]
  }
  // about: {
  //   id: 'footer-6',
  //   title: '关于拓弗勒',
  //   content: [{
  //     id: 'footer-6-1',
  //     text: '企业发展',
  //     src: '/'
  //   }, {
  //     id: 'footer-6-2',
  //     text: '品牌故事-品牌标识',
  //     src: '/'
  //   }, {
  //     id: 'footer-6-3',
  //     text: '品牌荣誉',
  //     src: '/'
  //   }, {
  //     id: 'footer-6-4',
  //     text: '投资优势',
  //     src: '/'
  //   }, {
  //     id: 'footer-6-5',
  //     text: '联系我们',
  //     src: '/'
  //   }]
  // }
};

if (isEn) {
  for (const k in footerData) {
    if (!footerDataLang[k].content || !footerDataLang[k].content.length)
      continue;
    footerData[k].title = footerDataLang[k].title;
    footerData[k].content.forEach((item, index) => {
      item.text = footerDataLang[k]["content"][index];
    });
  }
}
const dASData = {
  first: {
    title: "DAS数据辅助系统",
    content: [
      "DAS（数据辅助系统）由TOPS拓弗勒内部开发，是行业领先的3D 裁膜数据辅助系统，具有140,000多个车型数据模型。在TOPS拓弗勒认证安装人员手中，DAS提供的裁膜系统有效准确,保障安装人员精准完成工作的信心。在正式成为我们的合作伙伴以后，我们将提供30天免费试用，您可以见证DAS数据助理系统模式的精确度如何帮助您的业务取得成功"
    ]
  },
  second: {
    title: "漆面保护膜",
    content: [
      "  漆面保护膜一直是TOPS拓弗勒公司的核心产品。DAS(数据辅助系统)允许您立即帮您查询车型的数据模型。 DAS还提供安全、零风险的安装解决方案，它消除了手工切割的不精确性和危险，缩短了安装时间,并将效率提高了70％。",
      "目前，DAS包含近140,000种漆面保护套件，几乎适用于所有品牌和产品。 可以想到的车型。所有套件均精心设计，并考虑到最佳配件功能。"
    ]
  },
  third: {
    title: "漆面保护膜",
    content: ["拓+，拓,幻影哑光,幻影,羽裳"]
  },
  fourth: {
    title: "精确模式",
    content: [
      "拥有一个带有许多功能的软件包。 在TOPS拓弗勒，我们的两个主要设计目标是让漆面保护膜尽可能自然地装贴在汽车上，以避免不必要的拉伸和扭曲，并确保与车身完美贴合。",
      "除了这两个主要目标之外，我们的设计团队还致力于提供绝对没有无接缝和浮雕的设计。而且，如果需要一个接缝来装贴特别复杂的部件，我们的设计师将尽一切可能将其隐藏在身体上或不可见的面板的某些部分上。",
      "安装设计合理的预切套件可以在漆面保护膜业务中成功与失败之间产生差异。"
    ]
  },
  fifth: {
    title: "最高可用性",
    content: [
      "由于TOPS拓弗勒的产品工程师团队每天都在为新车辆创建设计模板，因此这些产品在完成后立即可以在软件中使用。无需等待发送更新包或下载完成。只需使用软件中的便捷搜索界面，即可获得新的和旧的每种模式。"
    ]
  },
  sixth: {
    title: "可变几何",
    content: [
      "拥有您需要的模式只是方程式的一部分。 为了确保客户满意度，无论其预算或期望如何，您都需要具有严格灵活性的切割计划。",
      "凭借我们的专利可变几何功能，您可以安全快速地实施几乎任何覆盖范围细节的变化，以确保您的客户以他们能够承受的价格获得他们期望的质量。包裹任何边缘，更改图案的覆盖范围甚至设计元素，但不会意外地进行更改，使部件无法使用。"
    ]
  },
  seventh: {
    title:
      "了解更多信息<br/>对TOPPF拓弗PPF安装培训有疑问？<br/>填写下面的联系表格：",
    content: ["下载DAS↓"]
  }
};
if (isEn) {
  for (const k in dASData) {
    if (!dASDataLang[k].content || !dASDataLang[k].content.length) continue;
    dASData[k].title = dASDataLang[k].title;
    dASData[k].content.forEach((item, index) => {
      console.log(dASDataLang[k]["content"][index]);
      dASData[k].content[index] = dASDataLang[k]["content"][index];
    });
  }
  console.log("Dasdata", dASData);
}
export {
  topList,
  navigationList,
  bannerList,
  developList,
  progressData,
  brandList,
  footerData,
  dASData
};



//////////////////
// WEBPACK FOOTER
// ./config/dictionary.js
// module id = BdcI
// module chunks = 0